import React, { useState, useEffect } from 'react';
import DOMPurify from "dompurify";
import axios from "axios";

function Services() {
    const [pageContent, setPageContent] = useState([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/CMSPage/GetPageContentById/216`)
            .then((response) => {
                setPageContent(response.data);
            });
    }, []);

    const leftContentHTML = DOMPurify.sanitize(pageContent.pgS_T_OTHERPAGECONTENT2);
    const rightImageHTML = DOMPurify.sanitize(pageContent.pgS_T_PAGECONTENT);

    return (
        <div>
            <section id="services-index" class="bg-pattern" data-bottom-top="background-position: 0px 70%,99% 70%;"
                data-top-bottom="background-position: 0px -50%,99% -50%;">
                <div class="container">
                    <div class="section-heading"><br /><br />
                        <h2>Our Services</h2>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-lg-7">
                            <div dangerouslySetInnerHTML={{ __html: leftContentHTML }} />
                        </div>
                        <div class="col-md-6 col-lg-5">
                            <div className='img-container' dangerouslySetInnerHTML={{ __html: rightImageHTML }} />
                        </div>                       
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services;